var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{attrs:{"value":_vm.value,"z-index":_vm.index}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }